import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/CommonService/data.service';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { GTCRequisitionservice } from 'src/app/Shared/GTCRequisition.service';
import { CommonService } from 'src/app/Shared/common.service';

@Component({
  selector: 'app-role-assignment',
  templateUrl: './role-assignment.component.html',
  styleUrls: ['./role-assignment.component.css']
})
export class RoleAssignmentComponent implements OnInit{

  constructor(private _dataService: DataService,
    private _commonservice: CommonService,
    private _router: Router,
    private _gtcService: GTCRequisitionservice,
    private _fb: FormBuilder,
    public _global: GlobalVariables) { }
  AppAccessForm!:FormGroup;
  selectedEmp:any;
  EmpDetails:any;
  pageIndex: number = 1;
  length: number = 0;
  totalPage: number = 0;
  IsLoadingResults: any;
  EmployeeDetails:any;
  rolesList:any;
  data:any = [];
  displayedColumns = [
    'EmpName', 'EmpEmail', 'SSL','Location','Role','EmpGPN'
  ];
  ngOnInit(): void {

 
    this._global.RecordSize=10;
    this.AppAccessForm = this._fb.group({
      Role: [''],
      EmpGPN:[''],
      EmpName: [''],
      SSL: [''],
      Location: [''],
      EmailId: [''],
      ID:[null],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize)
    });


    this._commonservice.BindDropDown('SAFRoles').subscribe(result => {
      this.rolesList = result;
    });

    this.GetAllEmpDetails();
  }
  onRoleChange(event : any){

  }
  onExit(){
    this._router.navigate(['/home']);
  }
  SearchRecord() {
    this.pageIndex = 1;
    this.length = 0;
    this.totalPage = 0;
    this.GetAllEmpDetails();
  }
  onSubmit(){
    this.IsLoadingResults = true;
    this.getFormControls('EmpName').setValue(null);

      this._gtcService.SaveUserAppDetails(this.AppAccessForm.value).subscribe((data:any) => {
    this.IsLoadingResults = false;
       
        alert(data.RequestMessage);
        if (data.RequestIsSuccess) {
          this.GetAllEmpDetails();
          
        } 
    }, (error:HttpErrorResponse) => {
      
       });
  
    

  }

  GetAllEmpDetails(){
    this.IsLoadingResults = true;

    this.AppAccessForm.controls['PageNumber'].setValue(this._global.pageIndex + 1);
    this.AppAccessForm.controls['PageSize'].setValue(this._global.RecordSize);
    this._gtcService.GetSAFData(this.AppAccessForm.value).subscribe((result:any) => {
    this.IsLoadingResults = false;

      this.data = result;
      if (this.data != null && this.data.length > 0) {
        this._global.length = this.data[0].Totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this._global.RecordSize);
      } else {
        this._global.length = 0;
        this._global.pageIndex = 1;
        this._global.totalPage = 0;
      }
    });
    

  }
  getEmpNames(event :any){
    if(!this.checkValueIsNullOrEmptyOrUndefined(event))
    {
      this.getFormControls('SSL').setValue(event.SSL);
      this.getFormControls('EmpGPN').setValue(event.EmpGPN);
      this.getFormControls('Location').setValue(event.Location);
      this.getFormControls('EmailId').setValue(event.EmpEmail);

  
    }
  }

  getFormControls(controlName : any){
    return this.AppAccessForm.controls[controlName];
  }
  ResetEmpDetails(){
    this.AppAccessForm.reset();
  }
  checkValueIsNullOrEmptyOrUndefined(value: any){
    if(value == null || value == undefined || value == "")
    {
      return  true;
    }
    else
    {
      return false;
    }
  }



  GetAllUserDetails() {
 
  }
  filterEmp(filter : any){
 
    this._commonservice.BindDropDownForEmpValues(filter.query).
    subscribe((result: any) => {
        this.EmpDetails = result;
    });
  }
  onOptionsSelected(){

  }

  GetResult(){
    this.GetAllEmpDetails();
  }
  Reset(){
    this.AppAccessForm.reset();
    this.SearchRecord();
  }
  onRemove(Id : any){
    this.getFormControls('EmpGPN').setValue(Id);
    this.getFormControls('EmpName').setValue(null);

    this._gtcService.RemoveUserAccess(this.AppAccessForm.value, true).subscribe((data:any) => {
      alert(data.RequestMessage);
      if (data.RequestIsSuccess) {
    this.getFormControls('EmpGPN').setValue(null);

        this.GetAllEmpDetails();
        
      } 
  }, (error:HttpErrorResponse) => {
    
     });


  }
  onPaginateChange(event : any){
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
  this.GetAllEmpDetails();

  }

}
